module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_13.5f946e26.png";